'use client'

import { LocalizationProvider as BaseLocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { type PropsWithChildren } from 'react'

export function LocalizationProvider({ children }: PropsWithChildren) {
  return <BaseLocalizationProvider dateAdapter={AdapterDayjs}>{children}</BaseLocalizationProvider>
}
